import "./Notes.html";

import "./EditSiteNotes/EditSiteNotesComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import NotesComponentController from "./NotesComponentController";

export default class NotesComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            site: "<",
        };
        this.controller = NotesComponentController;
        this.templateUrl = "/App/Components/Site/Overview/Notes/Notes.html";
    }
}

module("mmManagePortal").component("mmSiteNotesEdit", new NotesComponent());
